<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" :rules="rules" ref="form" label-width="70px">
        <div>
          <el-form-item v-if="classify" :label="title" prop="categoryCode" label-width="90px">
            <el-input maxlength="2" v-model="form.categoryCode" placeholder="请输入2位数字"></el-input>
          </el-form-item>
          <el-form-item :label="title2" prop="categoryName" label-width="90px" :rules="[$validate.fileName(20)]">
            <el-input maxlength="20" v-model="form.categoryName" placeholder="请输入专业名称"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="editNode()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "category-edit",
  components: {},
  props: ['row'],
  data () {
    let checkCode = (rule, value, callback) => {
      const code = /^([A-Z]|[a-z]|[\d]){2}$/;
      if (!value) {
        return callback()
      } else {
        if (code.test(value)) {
          return callback();
        } else {
          callback(new Error("专业/级别代码只允许输入数字、字母,长度必须2位"));
        }
      }
    };
    return {
      form: {},
      title: "",
      title2: "",
      classify: true,
      rules: {
        categoryCode: [{ validator: checkCode, trigger: "blur" }]
      }
    }
  },
  async created () {
    // debugger
    if (this.row.level == 1 && this.row.data.parentId) {
      this.title = "专业代码"
      this.classify = true
      this.form = {
        categoryName: this.row.categoryName || this.row.label,
        categoryCode: this.row.data.categoryCode
      }
    } else if (this.row.level == 2) {
      this.title = "级别代码"
      this.classify = true
      this.form = {
        categoryName: this.row.categoryName || this.row.label,
        categoryCode: this.row.data.categoryCode
      }
    } else {
      this.form = {
        categoryName: this.row.categoryName || this.row.label,
      }
      this.classify = false
    }
    if (this.row.level == 1 && this.row.data.parentId) {
      this.title2 = "专业名称"
      this.classify = true
      this.form = {
        categoryName: this.row.categoryName || this.row.label,
        categoryCode: this.row.data.categoryCode
      }
    } else if (this.row.level == 2) {
      this.title2 = "级别名称"
      this.classify = true
      this.form = {
        categoryName: this.row.categoryName || this.row.label,
        categoryCode: this.row.data.categoryCode
      }
    } else {
      this.title2 = "分类名称"
      this.form = {
        categoryName: this.row.categoryName || this.row.label,
      }
      this.classify = false
    }
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async editNode () {
      try {
        // debugger
        if (this.form.categoryName) {
          if (this.form.categoryCode) {
            const code = /^([A-Z]|[a-z]|[\d]){2}$/
            if (code.test(this.form.categoryCode)) {
              await this.$HTTP.ApiCategory.edit({ categoryId: this.row.categoryId || this.row.key, categoryName: this.form.categoryName, categoryCode: this.form.categoryCode })
              this.$emit('getTree')
            } else {
              // this.$message({ type: 'error', message: '请输入数字或字母组合且长度必须2位' })
              return
            }
          } else if (!this.form.categoryCode) {
            await this.$HTTP.ApiCategory.edit({ categoryId: this.row.categoryId || this.row.key, categoryName: this.form.categoryName, categoryCode: this.form.categoryCode })
            this.$emit('getTree')
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
  }
}
</script>

<style scoped>

</style>
